// İki dilli içerik ({ tr, en }) ve aktif dile göre seçim (fallback'li).
export type Localized = { tr?: string; en?: string };

export const pick = (v: Localized | undefined, lang: string): string =>
  (lang === 'en' ? v?.en || v?.tr : v?.tr || v?.en) || '';

// pick ile aynı, tek farkı: BOŞ STRING geçerli bir çeviri sayılır. Böylece
// "bu parça bu dilde YOK" demek için { en: '' } yazılabilir — Türkçede sona
// gelen yüklemin (Yönetin / Yapın / Projeler) İngilizce başlıkta hiç
// bulunmaması gibi. pick'te '' fallback'e düşüp Türkçe kelimeyi sızdırır;
// o davranış CMS'ten boş gelen alanlar için BİLEREK korunur (kaydın İngilizcesi
// girilmemişse Türkçesini göstermek boş göstermekten iyidir).
export const pickExact = (v: Localized | undefined, lang: string): string => {
  const primary = lang === 'en' ? v?.en : v?.tr;
  if (typeof primary === 'string') return primary;
  return (lang === 'en' ? v?.tr : v?.en) ?? '';
};
